import { toRouterRoutes } from './routes.config'

export const routes = toRouterRoutes()
